import React, { FC } from 'react';
import { PlannedTwinID } from '@ynomia/core/dist/blueprint';
import {
  getPlannedTwinIDChangesKeyedByTwinID,
} from '../../../../../../selectors';
import { getContextStores } from '../../../../../../context';
import DiffTable from '../../../../../../components/atoms/DiffTable';

interface Props {
  record: PlannedTwinID
}

const PlannedTwinIDDiffSubTable: FC<Props> = ({ record }) => {
  /* Context  */
  const contextStores = getContextStores();
  const { plannedTwinIDUpdateState } = contextStores;
  const { showChangesOnly } = plannedTwinIDUpdateState || {};

  /* Selectors */
  const plannedTwinIDChangesKeyedByTwinID = getPlannedTwinIDChangesKeyedByTwinID(
    contextStores,
  );
  const { twinID } = record;
  let changes = plannedTwinIDChangesKeyedByTwinID.get(twinID);

  changes = showChangesOnly
    ? changes?.filter(({ isValueChanged }) => isValueChanged !== 'none') : changes;

  if (!changes) return null;

  return (
    <DiffTable
      label={twinID}
      changes={changes}
    />
  );
};

export default PlannedTwinIDDiffSubTable;
